"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStatusTextColor = exports.getStatusColor = void 0;
var _sdk = require("../../../sdk");
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const statusToColor = {
  [_sdk.IssueStatus.Draft]: _alloyReactTheme.default.colors.charcoal900,
  [_sdk.IssueStatus.Open]: _alloyReactTheme.default.colors.yellowOrange500,
  [_sdk.IssueStatus.Pending]: _alloyReactTheme.default.colors.adskBlue500,
  [_sdk.IssueStatus.InProgress]: _alloyReactTheme.default.colors.darkBlue300,
  [_sdk.IssueStatus.Completed]: _alloyReactTheme.default.colors.green300,
  [_sdk.IssueStatus.InReview]: "#a76ef5",
  // No purple500 color constant in the theme
  [_sdk.IssueStatus.NotApproved]: _alloyReactTheme.default.colors.red500,
  [_sdk.IssueStatus.InDispute]: _alloyReactTheme.default.colors.red500,
  [_sdk.IssueStatus.Closed]: _alloyReactTheme.default.colors.charcoal200
};
const statusToTextColor = {
  [_sdk.IssueStatus.Draft]: _alloyReactTheme.default.colors.white,
  [_sdk.IssueStatus.Open]: _alloyReactTheme.default.colors.black,
  [_sdk.IssueStatus.Pending]: _alloyReactTheme.default.colors.white,
  [_sdk.IssueStatus.InProgress]: _alloyReactTheme.default.colors.black,
  [_sdk.IssueStatus.Completed]: _alloyReactTheme.default.colors.black,
  [_sdk.IssueStatus.InReview]: _alloyReactTheme.default.colors.white,
  [_sdk.IssueStatus.NotApproved]: _alloyReactTheme.default.colors.white,
  [_sdk.IssueStatus.InDispute]: _alloyReactTheme.default.colors.white,
  [_sdk.IssueStatus.Closed]: _alloyReactTheme.default.colors.black
};
const getStatusColor = status => statusToColor[status];
exports.getStatusColor = getStatusColor;
const getStatusTextColor = status => statusToTextColor[status];
exports.getStatusTextColor = getStatusTextColor;
//# sourceMappingURL=statusFieldHelpers.js.map